import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import isEmpty from "lodash/isEmpty";

// Components
import Select from "react-select";
import Loader from "../../utils/Loader";
import NumberFormat from 'react-number-format'
import CategorySearch from "../products/category-search/CategorySearch";
import ProductSearch from "../products/product-search/ProductSearch";

// State
import { loadTopTiers } from "../../../store/actions/topTier";

class BuyXGetY extends Component {
    constructor(props) {
        super(props)
        this.state = {
            updateLoading: false,
            loading: false,
        }
    }

    componentDidMount(){
        this.props.loadTopTiers();
    }

    render() {
        const {updateLoading, loading} = this.state;
        const {item, index, editId, topTiers} = this.props;

        const discountTypes = [
            {value: 'percentage', label: 'Percentage (%)'},
            {value: 'dollar', label: 'Dollar ($)'},
            {value: 'free', label: 'Free'}
        ];

        const reqTypes = [
            {value: 'value', label: 'Dollar ($)'},
            {value: 'quantity', label: 'Quantity (#)'}
        ];

        // Eligibility
        const eligibility_options = [{value: 0, label: 'All Customers'}];
        !isEmpty(topTiers) && topTiers.forEach(element => {
            eligibility_options.push({value: element.id, label: element.name});
        });

        return (
            <Fragment>
            {loading ? 
                <div className="pt2 pb2">
                    <Loader />
                </div> :
                <div className="discount-edit">
                    <div className="discount-edit-header">
                        {editId !== null ? "Edit Buy X Get Y Code:" : "Add Buy X Get Y  Code:"}
                    </div>
                    <div className="discount-edit-row1">
                        <div className="discount-edit-field">
                            {!!item.errors && !!item.errors.code && <div className="error msg_animate">{item.errors.code}</div>}
                            <div className='discount-edit-label'>Coupon Code:</div>
                            <input type="text" value={item.code} placeholder="Enter coupon code" onChange={e => this.props.handleChange(e.target.value, index, 'code')}/>
                        </div>
                        <div className="discount-edit-field">
                            {!!item.errors && !!item.errors.message && <div className="error msg_animate">{item.errors.message}</div>}
                            <div className='discount-edit-label'>Message:</div>
                            <input type="text" value={!!item.message ? item.message : ''} placeholder="Enter message" onChange={e => this.props.handleChange(e.target.value, index, 'message')}/>
                        </div>
                        <input type="hidden" value={item.id ? item.id : ""}></input>
                    </div>
                    <div className="discount-edit-row2">
                        <div className="bg">
                            {/* CUSTOMER BUYS - LEFT COL */}
                            <div className="bg-col">
                                <div className="bg-col-head">CUSTOMER BUYS</div>
                                <div className="bg-col-min">
                                    <div className="bg-col-min-head">Minimum Type & Amount</div>
                                    {!!item.errors && !!item.errors.req_value && <div className="error msg_animate">{item.errors.req_value}</div>}
                                    <div className="bg-col-min-form">
                                        <Select className="select-box" name={`req_type`} placeholder="Select Type" value={item.req_type === "" ? "value" : item.req_type} onChange={selection => this.props.handleSelectBoxChange(selection, "req_type")} clearable={false} valueKey="value" labelKey="label" options={reqTypes} />
                                        {item.req_type === "value" && <NumberFormat value={item.req_value} placeholder="0.00" prefix={'$'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onChange={e => this.props.handleChange(e.target.value, index, 'req_value')} renderText={formattedValue => <div>{formattedValue}</div>}/>}
                                        {item.req_type === "quantity" && <NumberFormat value={item.req_value} placeholder="0" prefix={''} decimalScale={0} fixedDecimalScale={false} thousandSeparator={true} onChange={e => this.props.handleChange(e.target.value, index, 'req_value')} renderText={formattedValue => <div>{formattedValue}</div>}/>}
                                    </div>
                                    {item.req_type === "value" ?
                                        <div className="custom-label checkbox-label nobuyitems-checkbox">
                                            <input type="checkbox" id="no_buy_items" checked={item.no_buy_items} disabled={item.buy_categories.length > 0 || item.buy_products.length > 0} onChange={e => this.props.handleCheckboxClick(index, 'no_buy_items')} />
                                            <label htmlFor="no_buy_items" className={`no-blue ${item.buy_categories.length > 0 || item.buy_products.length > 0 ? " disabled" : ""}`}>Only require dollar value?</label>
                                        </div>
                                        : <Fragment></Fragment>
                                    }
                                </div>
                                <div className="bg-col-error">{!!item.errors && !!item.errors.buy_error && <div className="error msg_animate">{item.errors.buy_error}</div>}</div>
                                <div className="bg-col-body">
                                    <div className="bg-col-body-col">
                                        <div className="bg-col-body-col-head">Products</div>
                                        <div className="bg-col-body-col-search">
                                            <ProductSearch
                                                currentlySelected={item.buy_products}
                                                updateHandler={selections => this.props.handleCatProdChange(selections, 'buy_products')}
                                                disabled={item.buy_categories.length > 0 || item.buy_products.length > 0 || item.no_buy_items}
                                                ignoreVariants={false}
                                            />
                                            <div className="selected-item-wrapper">
                                                {!!item.buy_products &&
                                                    item.buy_products.map((product, i) => {
                                                        return (
                                                            <div key={i} className="selected-item">
                                                                <div className="txt">{product.title}</div>
                                                                <input type="hidden" name="buy_products[]" value={product.id} />
                                                                <span className="icon-cross delete-category" onClick={() => { this.props.handleCatProdDelete(i, 'buy_products')}}/>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-col-body-col-seperator"></div>
                                    <div className="bg-col-body-col">
                                        <div className="bg-col-body-col-head">Categories</div>
                                        <div className="bg-col-body-col-search">
                                            <CategorySearch
                                                currentlySelected={item.buy_categories}
                                                updateHandler={selections => this.props.handleCatProdChange(selections, 'buy_categories')}
                                                disabled={item.buy_categories.length > 0 || item.buy_products.length > 0 || item.no_buy_items}
                                            />
                                            <div className="selected-item-wrapper">
                                                {!!item.buy_categories &&
                                                    item.buy_categories.map((category, i) => {
                                                        return (
                                                            <div key={i} className="selected-item">
                                                                <div className="txt">{category.title}</div>
                                                                <input type="hidden" name="buy_categories[]" value={category.id} />
                                                                <span className="icon-cross delete-category" onClick={() => { this.props.handleCatProdDelete(i, 'buy_categories')}}/>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* CUSTOMER GETS - RIGHT COL */}
                            <div className="bg-col">
                                <div className="bg-col-head">CUSTOMER GETS</div>
                                <div className="bg-col-min">
                                    <div className="bg-col-min-head">Discount Type & Amount</div>
                                    {!!item.errors && !!item.errors.discount_value && <div className="error msg_animate">{item.errors.discount_value}</div>}
                                    <div className="bg-col-min-form">
                                        <Select className="select-box" name={`discount_type`} placeholder="Select Type" value={item.discount_type === "" ? "percentage" : item.discount_type} onChange={selection => this.props.handleSelectBoxChange(selection, "discount_type")} clearable={false} valueKey="value" labelKey="label" options={discountTypes} />
                                        {item.discount_type === "percentage" && <NumberFormat value={item.discount_value} placeholder="0.00" suffix={'%'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onChange={e => this.props.handleChange(e.target.value, index, 'discount_value')} />}
                                        {item.discount_type === "dollar" && <NumberFormat value={item.discount_value} placeholder="0.00" prefix={'$'} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} onChange={e => this.props.handleChange(e.target.value, index, 'discount_value')} />}
                                        {item.discount_type === "free" && <NumberFormat value={"No Amount"} placeholder="No Amount" disabled={true} />}
                                    </div>
                                </div>
                                <div className="bg-col-error">{!!item.errors && !!item.errors.get_error && <div className="error msg_animate">{item.errors.get_error}</div>}</div>
                                <div className="bg-col-body">
                                    <div className="bg-col-body-col">
                                        <div className="bg-col-body-col-head">Products</div>
                                        <div className="bg-col-body-col-search">
                                            <ProductSearch
                                                currentlySelected={item.get_products}
                                                updateHandler={selections => this.props.handleCatProdChange(selections, 'get_products')}
                                                disabled={item.get_products.length > 0 || item.get_categories.length > 0}
                                                ignoreVariants={false}
                                            />
                                            <div className="selected-item-wrapper">
                                                {!!item.get_products &&
                                                    item.get_products.map((product, i) => {
                                                        return (
                                                            <div key={i} className="selected-item-qty-container">
                                                                <div className="selected-item">
                                                                    <div className="txt">{product.title}</div>
                                                                    <input type="hidden" name="get_products[]" value={product.id} />
                                                                    <span className="icon-cross delete-category" onClick={() => { this.props.handleCatProdDelete(i, 'get_products')}}/>
                                                                </div>
                                                                {!!item.errors && !!item.errors.discount_qty && <div className="error msg_animate" style={{margin: '0.75em 0em'}}>{item.errors.discount_qty}</div>}
                                                                <div className="qty-group">
                                                                    <div className="qty-label">Max Quantity: </div>
                                                                    <input type="number" placeholder="Enter quantity" value={item.discount_qty} onChange={e => this.props.handleChange(e.target.value, index, 'discount_qty')}/>
                                                                </div>
                                                                {item.get_products[0]['no_variants'] ?
                                                                <div className="custom-label checkbox-label autoadd-checkbox">
                                                                    <input type="checkbox" id="auto_add" checked={item.auto_add} onChange={e => this.props.handleCheckboxClick(index, 'auto_add')} />
                                                                    <label htmlFor="auto_add">Auto-add this product after coupon is applied?</label>
                                                                </div>
                                                                : <Fragment></Fragment>
                                                                }
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-col-body-col-seperator"></div>
                                    <div className="bg-col-body-col">
                                        <div className="bg-col-body-col-head">Categories</div>
                                        <div className="bg-col-body-col-search">
                                            <CategorySearch
                                                currentlySelected={item.get_categories}
                                                updateHandler={selections => this.props.handleCatProdChange(selections, 'get_categories')}
                                                disabled={item.get_products.length > 0 || item.get_categories.length > 0}
                                            />
                                            <div className="selected-item-wrapper">
                                                {!!item.get_categories &&
                                                    item.get_categories.map((category, i) => {
                                                        return (
                                                            <div key={i} className="selected-item-qty-container">
                                                                <div className="selected-item">
                                                                    <div className="txt">{category.title}</div>
                                                                    <input type="hidden" name="get_categories[]" value={category.id} />
                                                                    <span className="icon-cross delete-category" onClick={() => { this.props.handleCatProdDelete(i, 'get_categories')}}/>
                                                                </div>
                                                                {!!item.errors && !!item.errors.discount_qty && <div className="error msg_animate" style={{margin: '0.75em 0em'}}>{item.errors.discount_qty}</div>}
                                                                <div className="qty-group">
                                                                    <div className="qty-label">Max Quantity: </div>
                                                                    <input type="number" placeholder="Enter quantity" value={item.discount_qty} onChange={e => this.props.handleChange(e.target.value, index, 'discount_qty')}/>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div className="discount-edit-row3">
                        <div className="discount-edit-field">
                            <div className='discount-edit-label'>Max Coupon Code Uses:</div>
                            <input type="number" placeholder="Enter number. Leave blank for unlimited." maxLength={50} value={item.max_uses === null ? '' : item.max_uses} onChange={e => this.props.handleChange(e.target.value, index, 'max_uses')}/>
                        </div>
                        <div className="discount-edit-field">
                            {!!item.errors && !!item.errors.start_date && <div className="error msg_animate">{item.errors.start_date}</div>}
                            <div className='discount-edit-label'>Effective Date Start:</div>
                            <input type="date" placeholder="START DATE" maxLength={50} value={item.start_date} onChange={e => this.props.handleChange(e.target.value, index, 'start_date')}/>
                        </div>
                        <div className="discount-edit-field">
                            {!!item.errors && !!item.errors.end_date && <div className="error msg_animate">{item.errors.end_date}</div>}
                            <div className='discount-edit-label'>Effective Date End:</div>
                            <input type="date" placeholder="END DATE" maxLength={50} value={item.end_date} onChange={e => this.props.handleChange(e.target.value, index, 'end_date')}/>
                        </div>
                    </div>  

                    {!!item.errors && !!item.errors.top_tier_id && <div className="error msg_animate">{item.errors.top_tier_id}</div>}
                    <div className="discount-eligible">
                        <div class="discount-eligible-select">
                            <div className="discount-eligible-label">Customer Eligibility:</div>
                            <div className="discount-eligible-field">
                                <Select className="select-box" name={`top_tier_id`} value={item.top_tier_id} onChange={selection => this.props.handleSelectBoxChange(selection, "top_tier_id")} clearable={false} valueKey="value" labelKey="label" options={eligibility_options} />
                            </div>
                        </div>
                        <div className="custom-label checkbox-label nobuyitems-checkbox">
                            <input type="checkbox" id="ignore_toptier_discount" checked={item.ignore_toptier_discount} onChange={e => this.props.handleCheckboxClick(index, 'ignore_toptier_discount')} />
                            <label htmlFor="ignore_toptier_discount">Ignore Top Tier Discounts</label>
                        </div>
                    </div>
                    
                    <div className="discount-edit-row4">
                        <div>
                            {!!item.errors && !!item.errors.form && <div className="error msg_animate">{item.errors.form}</div>}
                            {this.props.success && <div className="success msg_animate">{this.props.success}</div>}
                            <button className={'btn ' + (updateLoading ? ' loading' : '')} disabled={updateLoading}
                                onClick={() => this.props.addItem()}
                            ><span>{editId !== null ? 'Update' : 'Add New'}</span></button>
                            {editId !== null &&
                            <button className={'btn ' + (updateLoading ? ' loading' : '')} disabled={updateLoading}
                                onClick={() => this.props.resetDiscountForm()}
                            ><span>Reset</span></button>
                            }
                        </div>
                    </div>
                </div>   
            }           
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        topTiers: state.topTier.topTiers
    }
}

export default connect(mapStateToProps, { loadTopTiers }) (BuyXGetY);




// WEBPACK FOOTER //
// ./src/components/admin/discounts/BuyXGetY.js